// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble$dGeneric from "../Unscramble.Generic/index.js";
const $Page = (tag, _1) => ({tag, _1});
const eq = /* #__PURE__ */ Data$dEq.eqArrayImpl(Data$dEq.eqStringImpl);
const MenuIsSymbol = {reflectSymbol: () => "Menu"};
const CartIsSymbol = {reflectSymbol: () => "Cart"};
const CheckoutIsSymbol = {reflectSymbol: () => "Checkout"};
const productIdsIsSymbol = {reflectSymbol: () => "productIds"};
const ProductCardIsSymbol = {reflectSymbol: () => "ProductCard"};
const Menu = /* #__PURE__ */ $Page("Menu");
const Cart = /* #__PURE__ */ $Page("Cart");
const Checkout = /* #__PURE__ */ $Page("Checkout");
const ProductCard = value0 => $Page("ProductCard", value0);
const toFillFormTypePage = {fillFormDataType: v => "unknown"};
const eqPage = {
  eq: x => y => {
    if (x.tag === "Menu") { return y.tag === "Menu"; }
    if (x.tag === "Cart") { return y.tag === "Cart"; }
    if (x.tag === "Checkout") { return y.tag === "Checkout"; }
    if (x.tag === "ProductCard") {
      if (y.tag === "ProductCard") { return eq(x._1.productIds)(y._1.productIds); }
      return false;
    }
    return false;
  }
};
const genericPage = {
  to: x => {
    if (x.tag === "Inl") { return Menu; }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return Cart; }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return Checkout; }
        if (x._1._1.tag === "Inr") { return $Page("ProductCard", x._1._1._1); }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "Menu") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "Cart") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)); }
    if (x.tag === "Checkout") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))); }
    if (x.tag === "ProductCard") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", x._1))); }
    $runtime.fail();
  }
};
const showPage = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(MenuIsSymbol);
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(CartIsSymbol);
    const $2 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(CheckoutIsSymbol);
    const $3 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $3 = Data$dShow.showArrayImpl(Data$dShow.showStringImpl);
      return {genericShowArgs: v => ["{ productIds: " + $3(v.productIds) + " }"]};
    })())(ProductCardIsSymbol);
    return x => {
      const $4 = genericPage.from(x);
      if ($4.tag === "Inl") { return $0["genericShow'"]($4._1); }
      if ($4.tag === "Inr") {
        if ($4._1.tag === "Inl") { return $1["genericShow'"]($4._1._1); }
        if ($4._1.tag === "Inr") {
          if ($4._1._1.tag === "Inl") { return $2["genericShow'"]($4._1._1._1); }
          if ($4._1._1.tag === "Inr") { return $3["genericShow'"]($4._1._1._1); }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodePage = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(MenuIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(CartIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(CheckoutIsSymbol))(Unscramble$dGeneric.genericDecodeSumConstruct(ProductCardIsSymbol)({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons(productIdsIsSymbol)({unsafeDecode: Unscramble.decodeArray(Unscramble.decodeString)})(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
    })))))(Unscramble$dGeneric.defaultOptions);
    return x => genericPage.to($0(x));
  })()
};
const encodePage = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericPage)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor(MenuIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor(CartIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $2 = Foreign$dGeneric$dClass.genericEncodeConstructor(CheckoutIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $3 = Foreign$dGeneric$dClass.genericEncodeConstructor(ProductCardIsSymbol)((() => {
      const $3 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(productIdsIsSymbol)((() => {
        const encode1 = Data$dFunctor.arrayMap(Unsafe$dCoerce.unsafeCoerce);
        return {encodeWithOptions: v => encode1};
      })());
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $3.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    return {
      encodeOpts: v => v1 => {
        if (v1.tag === "Inl") { return $0.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1); }
        if (v1.tag === "Inr") {
          if (v1._1.tag === "Inl") { return $1.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1); }
          if (v1._1.tag === "Inr") {
            if (v1._1._1.tag === "Inl") { return $2.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1); }
            if (v1._1._1.tag === "Inr") { return $3.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1); }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
    };
  })())
};
const decodePage = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericPage)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(MenuIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(CartIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(CheckoutIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ProductCardIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(productIdsIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Foreign$dGeneric$dClass.arrayDecode(Foreign$dGeneric$dClass.stringDecode).decode;
    return {decodeWithOptions: v => decode2};
  })())())))(Foreign$dGeneric$dClass.genericCountArgsArgument)))))
};
export {
  $Page,
  Cart,
  CartIsSymbol,
  Checkout,
  CheckoutIsSymbol,
  Menu,
  MenuIsSymbol,
  ProductCard,
  ProductCardIsSymbol,
  decodePage,
  encodePage,
  eq,
  eqPage,
  genericPage,
  productIdsIsSymbol,
  showPage,
  toFillFormTypePage,
  unscrambleDecodePage
};
